import $ from 'jquery';
import 'datatables.net';
function filterClick(i) {
    $('#coursemomenttable').DataTable().column(2).search(i).draw();
}

$(document).ready(function () {
    $('#coursemomenttable').DataTable({
        "sDom": '<"top"i>rt<"bottom"><"clear">',
        "paging": false,
        "info": false,
        "responsive": true,
        "autoWidth": true, 
        "order": [[ 1, "asc" ]]
    });

    $(".js-filterlink").on("click", function () {
        filterClick($(this).attr('data-value'));
        $(".js-filterlink").removeClass("active"); 
        $(this).addClass("active");
    });
});